export default __webpack_public_path__ + "static/media/kittyGarelly_avatar.b94e18ff.jpg";